import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningTriangleIcon } from "@progress/kendo-svg-icons";

interface SingleFileOverwriteConfirmDialogProperties {
  fileName: string;
  existingSize: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const formatSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;

  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex++;
  }

  return `${value.toFixed(1)} ${units[unitIndex]}`;
};

export const SingleFileOverwriteConfirmDialog: React.FC<SingleFileOverwriteConfirmDialogProperties> = ({ fileName, existingSize, onConfirm, onCancel }) => (
  <Dialog title="File already exists" onClose={onCancel} width={480}>
    <div style={{ padding: "10px" }}>
      <div role="alert" style={{ display: "flex", alignItems: "flex-start", gap: "8px", color: "#b26a00" }}>
        <SvgIcon icon={warningTriangleIcon} />
        <span>
          <strong>{fileName}</strong> already exists at this destination ({formatSize(existingSize)}). Continuing will permanently replace the stored file.
        </span>
      </div>
    </div>
    <DialogActionsBar>
      <Button onClick={onCancel}>Cancel</Button>
      <Button themeColor="warning" onClick={onConfirm}>
        Overwrite
      </Button>
    </DialogActionsBar>
  </Dialog>
);
